import { Component } from '@angular/core';

@Component({
    selector: 'ndt-register-create-options',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class RegisterCreateOptionsComponent {}
